import { getEnumWinStreakStatusName } from '../autogen/bundle.js';

/**
 * @typedef { import("../auth.js").Role } Role
 */

import { getStrWithLowFirstLetter } from '../util.js';
import { isRoleAdmin              } from '../util.js';
import { getOptionalTextMomentStr } from '../util.js';
import { getDurationStrSimple     } from '../util.js';

export const WIN_STREAK_STATUS_ACTIVE   = 1;
export const WIN_STREAK_STATUS_INCOMING = 2;
export const WIN_STREAK_STATUS_CLOSED   = 3;

export function isWinStreakStatusActive(status) {
  return status === WIN_STREAK_STATUS_ACTIVE;
}

export function getWinStreakStatusName(status) {
  const name = getEnumWinStreakStatusName(status);
  return getStrWithLowFirstLetter(name);
}

export function getWinStreakStatusClass(status) {
  return {
    activeWinStreak: isWinStreakStatusActive(status),
  };
}

/**
 * @param {Role} role 
 * @returns {boolean}
 */
export function mayManageWinStreaks(role) {
  return isRoleAdmin(role);
}

export function isWinStreakForQA(qaStatus) {
  return qaStatus === 1;
}

export function getWinStreakForQAClass(for_qa) {
  return {
    activeWinStreak: isWinStreakForQA(for_qa),
  };
}

//-----------------------------------------------------------------------------

export function convertWinStreakTypeArrayToTypeNameMap(typeArray) {
  if(typeArray === undefined) {
    return null;
  }
  if(typeArray === null) {
    return null;
  }

  const typeNameMap = new Map();
  for(const t of typeArray) {
    typeNameMap.set(t.id, t.name);
  }
  return typeNameMap;
}

export function getWinStreakTypeNameFromMap(typeNameMap, winStreakProtoId) {
  if(typeNameMap === null) {
    return getFallbackWinStreakTypeName(winStreakProtoId);
  }

  const name = typeNameMap.get(winStreakProtoId);
  if(name === undefined) {
    return getFallbackWinStreakTypeName(winStreakProtoId);
  }
  return name;
}

/**
 * @param {number|undefined} winStreakProtoId
 * @returns {string}
 */
function getFallbackWinStreakTypeName(winStreakProtoId) {
  if(winStreakProtoId === undefined) {
    return 'Win streak proto ?';
  }
  return 'Win streak proto ' + winStreakProtoId.toString();
}

//-----------------------------------------------------------------------------

export function getWinStreakRealStartTimeStr(time) {
  return getOptionalTextMomentStr(time, '---'); // не началось
}

export function getWinStreakRealFinishTimeStr(time) {
  return getOptionalTextMomentStr(time, '---'); // не завершено
}

export function getWinStreakRemainingTimeStr(winStreak, nowSec) {
  if(winStreak.status === WIN_STREAK_STATUS_INCOMING) {
    return '---'; // не началось
  }

  if(winStreak.status === WIN_STREAK_STATUS_CLOSED) {
    return '---'; // завершено
  }

  const timeEnded = nowSec >= winStreak.ftime;
  if(timeEnded) {
    return 'time ended';
  }

  const remainintTime = winStreak.ftime - nowSec;
  return getDurationStrSimple(remainintTime);
}
